import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageHeaderComponent } from '../../shared/components/ui-shell.component';
import { MonitoringService } from '../../services/monitoring.service';
import { Station } from '../../models/monitoring.models';

@Component({
  selector: 'app-station-select',
  standalone: true,
  imports: [FormsModule, PageHeaderComponent],
  template: `
    <div class="screen">
      <app-page-header title="Surveillance des DAT" />

      <div class="content">
        @if (!searchOpen()) {
          <button type="button" class="select-trigger" (click)="openSearch()">
            {{ selectedLabel() }}
          </button>
        } @else {
          <div class="search-panel">
            <input
              type="text"
              class="search-input"
              placeholder="Rechercher une gare..."
              [ngModel]="query()"
              (ngModelChange)="onQueryChange($event)"
              autofocus
            />
            <ul class="suggestions">
              @for (station of filtered(); track station.id) {
                <li>
                  <button type="button" class="suggestion-item" (click)="pick(station)">
                    {{ station.name }}
                  </button>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  `,
  styles: [
    `
      .screen {
        min-height: 100%;
        display: flex;
        flex-direction: column;
      }

      .content {
        padding: 1.5rem 1rem;
        flex: 1;
      }

      .select-trigger {
        width: 100%;
        text-align: left;
        padding: 0.85rem 1rem;
        border: 1px solid #888;
        border-radius: 999px;
        background: #fff;
        font-size: 1rem;
        color: #666;
        cursor: pointer;
      }

      .search-input {
        width: 100%;
        padding: 0.75rem 1rem;
        border: 1px solid #888;
        border-radius: 8px;
        font-size: 1rem;
        box-sizing: border-box;
      }

      .suggestions {
        list-style: none;
        margin: 0.5rem 0 0;
        padding: 0;
        border: 1px solid #ccc;
        border-radius: 8px;
        overflow: hidden;
      }

      .suggestion-item {
        width: 100%;
        text-align: left;
        padding: 0.85rem 1rem;
        border: none;
        border-bottom: 1px solid #eee;
        background: #fff;
        font-size: 1rem;
        cursor: pointer;
      }

      .suggestion-item:hover {
        background: #f5f5f5;
      }

      .suggestions li:last-child .suggestion-item {
        border-bottom: none;
      }
    `,
  ],
})
export class StationSelectComponent {
  private readonly monitoring = inject(MonitoringService);
  private readonly router = inject(Router);

  readonly searchOpen = signal(false);
  readonly query = signal('');
  readonly filtered = signal<Station[]>([]);

  selectedLabel(): string {
    return 'Sélectionner une gare';
  }

  openSearch(): void {
    this.searchOpen.set(true);
    this.monitoring.getStations().subscribe((stations) => this.filtered.set(stations));
  }

  onQueryChange(value: string): void {
    this.query.set(value);
    this.monitoring.searchStations(value).subscribe((stations) => this.filtered.set(stations));
  }

  pick(station: Station): void {
    this.router.navigate(['/gare', station.id, 'historique']);
  }
}
